import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import type {
  StatusPelaksanaanPengembanganKompetensi,
  StatusPelaksanaanPerilakuKerja,
  StatusPelaksanaanPraktikKinerja,
} from 'types/kinerja-ps-pegawai'

const PRAKTIK_KINERJA_BADGE_MAPPING: Record<
  StatusPelaksanaanPraktikKinerja,
  {
    variant: BadgeProps['variant']
    text: string
  }
> = {
  DISKUSI_PERSIAPAN: {
    variant: 'neutral',
    text: 'Diskusi Persiapan',
  },
  PENDAMPINGAN_SEKOLAH: {
    variant: 'neutral',
    text: 'Pendampingan Satuan Pendidikan',
  },
  DISKUSI_TINDAK_LANJUT: {
    variant: 'neutral',
    text: 'Rencana Tindak Lanjut',
  },
  DISKUSI_TINDAK_LANJUT_PENILAIAN: {
    variant: 'neutral',
    text: 'Rencana Tindak Lanjut',
  },
  UPAYA_TINDAK_LANJUT: {
    variant: 'neutral',
    text: 'Upaya Tindak Lanjut',
  },
  REFLEKSI_TINDAK_LANJUT: {
    variant: 'neutral',
    text: 'Refleksi dan Evaluasi Tindak Lanjut',
  },
  REFLEKSI_TINDAK_LANJUT_PENILAIAN: {
    variant: 'neutral',
    text: 'Refleksi dan Evaluasi Tindak Lanjut',
  },
  SELESAI: {
    variant: 'success',
    text: 'Sudah Selesai',
  },
}

function PelaksanaanPraktikKinerjaBadge({
  state,
}: {
  state: StatusPelaksanaanPraktikKinerja
}) {
  let badgeProps = PRAKTIK_KINERJA_BADGE_MAPPING[state]

  if (!badgeProps) {
    console.error(`Unknown praktik kinerja state: ${state}`)

    badgeProps = {
      variant: 'warning',
      text: 'Belum Selesai',
    }
  }

  return <Badge variant={badgeProps.variant}>{badgeProps.text}</Badge>
}

const PERILAKU_KERJA_BADGE_MAPPING: Record<
  StatusPelaksanaanPerilakuKerja,
  {
    variant: BadgeProps['variant']
    text: string
  }
> = {
  MULAI_LAKSANAKAN: {
    variant: 'warning',
    text: 'Belum Selesai',
  },
  SUDAH_DINILAI: {
    variant: 'success',
    text: 'Sudah Selesai',
  },
}

function PelaksanaanPerilakuKerjaBadge({
  state,
}: {
  state: StatusPelaksanaanPerilakuKerja
}) {
  let badgeProps = PERILAKU_KERJA_BADGE_MAPPING[state]

  if (!badgeProps) {
    console.error(`Unknown perilaku kerja state: ${state}`)

    badgeProps = {
      variant: 'warning',
      text: 'Belum dinilai',
    }
  }

  return <Badge variant={badgeProps.variant}>{badgeProps.text}</Badge>
}

const PENGEMBANGAN_KOMPETENSI_BADGE_MAPPING: Record<
  StatusPelaksanaanPengembanganKompetensi,
  {
    variant: BadgeProps['variant']
    text: string
  }
> = {
  MULAI_REFLEKSI: {
    variant: 'neutral',
    text: 'Belum Selesai',
  },
  SUDAH_REFLEKSI: {
    variant: 'success',
    text: 'Sudah Selesai',
  },
}

function PelaksanaanPengembanganKompetensiBadge({
  state,
}: {
  state: StatusPelaksanaanPengembanganKompetensi
}) {
  let badgeProps = PENGEMBANGAN_KOMPETENSI_BADGE_MAPPING[state]

  if (!badgeProps) {
    console.error(`Unknown pengembangan kompetensi state: ${state}`)

    badgeProps = {
      variant: 'neutral',
      text: 'Belum Selesai',
    }
  }

  return <Badge variant={badgeProps.variant}>{badgeProps.text}</Badge>
}

export const PraktikKinerja = PelaksanaanPraktikKinerjaBadge
export const PerilakuKerja = PelaksanaanPerilakuKerjaBadge
export const PengembanganKompetensi = PelaksanaanPengembanganKompetensiBadge
